package com.sweetlime.dungeonamigo.repository

import com.sweetlime.dungeonamigo.model.UserProfile
import dev.gitlive.firebase.firestore.FirebaseFirestore

class FirebaseUserRepository(
    private val authRepository: AuthRepository,
    private val firestore: FirebaseFirestore,
) : UserRepository {

    override suspend fun createUserProfile(profile: UserProfile) {
        firestore.collection("users")
            .document(profile.id)
            .set(profile.copy(usernameLower = profile.username.lowercase()))
    }

    override suspend fun getUserProfile(userId: String): UserProfile? {
        return try {
            firestore.collection("users").document(userId).get().data<UserProfile>()
        } catch (e: Exception) { null }
    }

    override suspend fun updateUsername(userId: String, username: String) {
        firestore.collection("users").document(userId)
            .update("username" to username, "usernameLower" to username.lowercase())
    }

    override suspend fun updateAvatar(userId: String, avatarUrl: String) {
        firestore.collection("users").document(userId).update("avatarUrl" to avatarUrl)
    }

    override suspend fun updateAvatarId(userId: String, avatarId: String) {
        firestore.collection("users").document(userId).update("avatarId" to avatarId)
    }

    override suspend fun updateTier(userId: String, tier: String) {
        firestore.collection("users").document(userId).update("tier" to tier)
    }

    override suspend fun updatePortraitColors(userId: String, primary: Long, secondary: Long) {
        firestore.collection("users").document(userId)
            .update("portraitPrimaryColor" to primary.toDouble(), "portraitSecondaryColor" to secondary.toDouble())
    }

    override suspend fun incrementSessionsPlayed(userId: String) {
        val profile = getUserProfile(userId) ?: return
        firestore.collection("users").document(userId)
            .update("sessionsPlayed" to profile.sessionsPlayed + 1)
    }

    override suspend fun deleteUserData(userId: String) {
        val subcollections = listOf("characters", "campaigns")
        for (sub in subcollections) {
            firestore.collection("users").document(userId).collection(sub)
                .get().documents.forEach { it.reference.delete() }
        }
        firestore.collection("users").document(userId).delete()
    }
}
